function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Service from '@ember/service';
import { getOwner } from '@ember/application';
export default class EnsureRegisteredService extends Service {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "classNonces", new WeakMap());

    _defineProperty(this, "nonceCounter", 0);
  }

  register(klass, owner = getOwner(this)) {
    let nonce = this.classNonces.get(klass);

    if (nonce == null) {
      nonce = `-ensure${this.nonceCounter++}`;
      this.classNonces.set(klass, nonce);
      owner.register(`component:${nonce}`, klass);
    }

    return nonce;
  }

}